import { useQuery } from "@apollo/client";
import { getProcessedData } from "./utils";
import fetch from "cross-fetch";

export const DynamicApolloProvider = ({ element }) => {
  const { ApolloClient, InMemoryCache, HttpLink, ApolloProvider } = require("@apollo/client");

  const client = new ApolloClient({
    link: new HttpLink({
      uri: `${process.env.WP_URL}/graphql`,
      fetch,
    }),
    cache: new InMemoryCache({
      typePolicies: {
        RootQuery: {
          queryType: true,
        },
    }
    }),
  });

  return <ApolloProvider client={client}>{element}</ApolloProvider>;
};

export const usePreviewData = (query, slug) => {
  let id = 0;
  let processedData;

  if (slug.includes("draft-page-")) {
    id = parseInt(slug.split("draft-page-")[1]);
  }

  const { loading, error, data } = useQuery(query, {
    variables: { uri: `${slug}`, pageId: id },
  });

  if (data?.page) {
    const currentLanguage = data.page.language?.code || "FI";
    processedData = getProcessedData(
      data,
      currentLanguage
    );
  }

  return { loading, error, data: processedData };
};
